import type React from "react";
import {memo, useMemo} from "react";

import SelectGeneric from "../SelectGeneric";

type Props = {
    value?: string;
    isDisabled?: boolean;
    onChange: (value: string) => void;
};

const SelectLimitEvent: React.FC<Props> = ({isDisabled, value = "checkout", onChange}) => {
    const options = useMemo(
        () => [
            {
                value: "checkin",
                label: "Guest Checks-In"
            },
            {
                value: "checkout",
                label: "Guest Checks-Out"
            }
        ],
        []
    );

    return (
        <SelectGeneric
            isDisabled={isDisabled}
            options={options}
            placeholder="Event..."
            testID="select-limit-event"
            value={value}
            onChange={onChange}
        />
    );
};

export default memo(SelectLimitEvent);
